export default function ContactSection() {
  return (
    <section id="contact" className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-2">爆料投稿</h2>
        <p className="text-sm text-foreground-500 mb-8">你有独家内幕？欢迎向我们投稿爆料，一起吃瓜</p>
        <div className="bg-background-50 rounded-xl border border-background-200/70 p-6 md:p-8">
          <div className="flex flex-col md:flex-row gap-6 items-start">
            <div className="flex-shrink-0 w-14 h-14 flex items-center justify-center rounded-xl bg-primary-100">
              <i className="ri-send-plane-line text-primary-600 text-2xl"></i>
            </div>
            <div className="flex-1">
              <h3 className="text-base font-semibold text-foreground-900 mb-2">成为我们的爆料人</h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-5">
                如果你掌握了网红明星的最新内幕、独家八卦或行业黑料，欢迎通过以下方式联系我们。我们承诺对爆料人信息严格保密，核实后将第一时间发布，让你成为全网最前沿的吃瓜信息源。
              </p>
              <div className="flex flex-col sm:flex-row gap-3">
                <div className="flex items-center gap-2 px-4 py-2.5 rounded-lg bg-background-100 border border-background-200/60 flex-1">
                  <i className="ri-mail-line text-primary-500 text-lg"></i>
                  <span className="text-sm text-foreground-700">爆料邮箱：tip@chigua.example.com</span>
                </div>
                <div className="flex items-center gap-2 px-4 py-2.5 rounded-lg bg-background-100 border border-background-200/60 flex-1">
                  <i className="ri-wechat-line text-primary-500 text-lg"></i>
                  <span className="text-sm text-foreground-700">微信：chigua_tips</span>
                </div>
              </div>
              <p className="text-xs text-foreground-400 mt-4">
                * 所有投稿将经过编辑审核，优质爆料可获得现金奖励
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}